import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/testimonials';

export const TestimonialsSection = () => {
  return (
    <section className="py-24 px-6 bg-brand-blush/40" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="uppercase tracking-[0.2em] text-xs font-bold text-brand-gold mb-4">
            Customer Stories
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-light tracking-tight text-brand-green-dark">
            Loved by Hyderabad
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="gold-border-glow bg-brand-cream p-8 rounded-sm smooth-transition"
              data-testid={`testimonial-card-${testimonial.id}`}
            >
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={`${testimonial.id}-star-${i}`}
                    className="w-4 h-4 fill-brand-gold text-brand-gold"
                    strokeWidth={1.5}
                  />
                ))}
              </div>

              <p className="font-body text-base leading-relaxed font-light text-brand-green-dark mb-6">
                "{testimonial.text}"
              </p>

              <div className="border-t border-brand-gold/30 pt-4">
                <p className="font-body font-normal text-brand-green-dark">
                  {testimonial.name}
                </p>
                <p className="font-body text-sm text-brand-green-dark/60">
                  {testimonial.location}
                </p>
                <p className="font-body text-xs uppercase tracking-wider text-brand-gold mt-2">
                  {testimonial.orderType} • {testimonial.date}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
